import CloseIcon from '@mui/icons-material/Close';
import {
    AppBar,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    Slide,
    Toolbar,
    Typography,
    useTheme
} from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import React, { FC, forwardRef, useMemo, useState } from 'react';
import { SearchInput } from '../../../Form/InputSearch/input-search.component';
import { useToast } from '../../../../Hooks/ToasContext';
import { Table } from '../../../Table/table.component';
import { ListSellersUseCase } from '../../../../Usecase/Sellers/list-sellers-usecase';
import { ISellerEntity } from '../../../../Services/api/sellers/sellers.interface';
interface ISelectSellerVariantProps {
    data: any
    onClose: () => void
    onSearch: (value: string) => void
    onSelect: (value: any) => void
    listSellersUseCase: ListSellersUseCase
}

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
  }

const SelectSellerVariant : FC<ISelectSellerVariantProps> = ({ data, onClose, onSearch, onSelect, listSellersUseCase }) => {
    const [loading, setLoading] = useState(false)
    const [customers, setSellers] = useState<ISellerEntity[]>([])
    const { showToast } = useToast()

    const Transition = forwardRef(function Transition(
        props: TransitionProps & {
        children: React.ReactElement<any, any>;
        },
        ref: React.Ref<unknown>,
    ) {
        return <Slide direction="up" ref={ref} {...props} />;
    });
  
  const listSellers = async ({ page, search }: { page :number; search?: string}) => {
        
    try {
      setLoading(true)
      
      const listResult = await listSellersUseCase.handle({ page: 1, searchBy: search});

      if (listResult.isFailure) {
        showToast(String(listResult?.error?.error), 'error');
        return;
      }

     const response = listResult.getValue()

      console.log("listSellers: ", response)

      if(response?.data?.length) {
        setSellers(response?.data)
      } else {
        setSellers([])
      }
      
   
     

    } catch (error) {
      console.log("error listArts function: ", error)
    } finally {
      setLoading(false);
    }
  };

const columns = useMemo(() => {
    const createColumns: any[] = [
      
      {
        field: 'name',
        flex: 1,
        headerName: 'Vendedor',
      }
    ];
  
    return createColumns;
  }, []);

  

  return (
    <>
      <Dialog
        open
        // TransitionComponent={Transition}
        keepMounted
        onClose={onClose}
        aria-describedby="alert-dialog-slide-description"
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Buscar Vendedor</DialogTitle>
        <DialogContent>
           <SearchInput
                sx={{ width: '100%', }}
                placeholder="Busque pelo nome do vendedor..."
                onSearch={listSellers}
            />

            

            <Table data={customers} columns={columns} totalCount={0} pagination={false} isRowSelectable={() => false} disableRowSelectionOnClick={false} onSelect={onSelect} onRowClick={onSelect} />

        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancelar</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SelectSellerVariant;
